/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from "react"
import "core-js/features/set-immediate"

import "./src/config"

// eslint-disable-next-line css-import-order/css-import-order
import "semantic-ui-css/semantic.min.css"
// eslint-disable-next-line css-import-order/css-import-order
import "balloon-css/balloon.min.css"
// eslint-disable-next-line css-import-order/css-import-order
import "decentraland-ui/dist/themes/base-theme.css"
// eslint-disable-next-line css-import-order/css-import-order
import "decentraland-ui/dist/themes/alternative/light-theme.css"
// eslint-disable-next-line css-import-order/css-import-order
import "./src/theme.css"

import Layout from "decentraland-gatsby/dist/components/Layout/Layout"
import UserInformation from "decentraland-gatsby/dist/components/User/UserInformation"
import AuthProvider from "decentraland-gatsby/dist/context/Auth/AuthProvider"
import FeatureFlagProvider from "decentraland-gatsby/dist/context/FeatureFlag/FeatureFlagProvider"
import { IntlProvider } from "decentraland-gatsby/dist/plugins/intl"
import env from "decentraland-gatsby/dist/utils/env"
import segment from "decentraland-gatsby/dist/utils/segment/segment"
// import PlayMenu from "./src/components/Layout/PlayMenu"

const SSO_URL = env("GATSBY_SSO_URL")

export const wrapRootElement = ({ element }) => (
  <>
    <AuthProvider sso={SSO_URL}>
      <FeatureFlagProvider endpoint="https://feature-flags.decentraland.org/dao.json">
        {element}
      </FeatureFlagProvider>
    </AuthProvider>
  </>
)

export const wrapPageElement = ({ element, props }) => {
  return (
    <IntlProvider {...props.pageContext.intl}>
      <Layout
        {...props}
        className={
          props.location.pathname === "/"
            ? "theme--white-text"
            : "theme--black-text"
        }
        rightMenu={<UserInformation />}
        isFullscreen={props.location.pathname.includes("/grants")}
      >
        {element}
      </Layout>
    </IntlProvider>
  )
}

export const onClientEntry = () => {
  segment((analytics) => analytics.page())
}

export const onRouteUpdate = () => {
  segment((analytics) => analytics.page())
}
